module.exports = __webpack_public_path__ + "static/Video-conferencing Tool-4fe247abb7c2d699c7105ecf63c0b9c2.svg";